import React from 'react';
import { Container, Row, Col, Button, Form } from 'react-bootstrap';
import './ContactSection.css';
import '../common-styles.css';
import indiaFlag from '../../assets/images/icons/india.svg';
import phoneIcon from '../../assets/images/icons/phone.png';
import locationIcon from '../../assets/images/icons/location.png';
import personIcon from '../../assets/images/icons/person.png';
import emailIcon from '../../assets/images/icons/email.png';
import textIcon from '../../assets/images/icons/text.png';

interface ContactSectionProps { showHeading?: boolean; }

const ContactSection: React.FC<ContactSectionProps> = ({ showHeading = true }) => {
  const handleSubmit: React.FormEventHandler = (e) => {
    e.preventDefault();
    // Placeholder submit logic
  };

  const openMap = (location: string) => {
    // Placeholder map link (could integrate Google Maps query)
    window.open(`https://www.google.com/maps/search/${encodeURIComponent(location)}`, '_blank');
  };

  return (
    <section className="contact-section section">
      <Container>
        {showHeading && (
          <h2 className="contact-heading text-center mb-5">
            <span className="section-title-highlight">Crafting Connections.</span> Creating Legacy.
          </h2>
        )}
        <div className="contact-card">
          <Row className="g-0">
            <Col lg={6} className="contact-left">
              <div className="contact-left-inner">
                <h3 className="contact-subheading mb-4">Let’s Talk About You</h3>
                <Form onSubmit={handleSubmit} className="contact-form">
                  <div className="contact-field">
                    <span className="field-icon"><img src={personIcon} alt="Person icon" className="icon-img" /></span>
                    <Form.Control placeholder="Name" required />
                  </div>
                  <div className="contact-field">
                    <span className="field-icon"><img src={emailIcon} alt="Email icon" className="icon-img" /></span>
                    <Form.Control type="email" placeholder="Email" required />
                  </div>
                  <div className="contact-field">
                    <span className="field-icon"><img src={phoneIcon} alt="Phone icon" className="icon-img" /></span>
                    <Form.Control type="tel" placeholder="Mobile Number" required />
                  </div>
                  <div className="contact-field textarea">
                    <span className="field-icon"><img src={textIcon} alt="Message icon" className="icon-img" /></span>
                    <Form.Control as="textarea" rows={5} placeholder="Your message" />
                  </div>
                  <div className="contact-note-submit-row mb-4">
                    <p className="contact-note mb-0">Simply fill out the form or email us at <a href="mailto:sundiam@ymail.com">sundiam@ymail.com</a></p>
                    <Button type="submit" className="section-btn submit-btn">
                      <span className="btn-content">Submit <i className="fas fa-arrow-right ms-2 btn-arrow-diagonal" /></span>
                    </Button>
                  </div>
                </Form>
              </div>
            </Col>
            <Col lg={6} className="contact-right">
              <div className="contact-right-inner">
                <h3 className="contact-subheading mb-4">Our Offices</h3>
                <div className="office-block mb-4">
                  <div className="office-heading"><img src={indiaFlag} alt="India flag" className="flag-icon" /> <span className="office-title">Maharashtra, Mumbai (HQ)</span></div>
                  <p className="office-address">EC-6051/52, Bharat Diamond Bourse, Bandra Kurla Complex, Bandra-East, Mumbai-400051</p>
                  <Button className="section-btn office-map-btn" onClick={() => openMap('Bharat Diamond Bourse Mumbai')}>
                    <span className="btn-content"><img src={locationIcon} alt="Location icon" className="icon-img me-2" /> Click Here</span>
                  </Button>
                </div>
                <div className="office-block mb-5">
                  <div className="office-heading"><img src={indiaFlag} alt="India flag" className="flag-icon" /> <span className="office-title">Surat, Gujrat (Factory)</span></div>
                  <p className="office-address">401, 4th floor Prayosha Sagar Industrial Estate, Nr. SMC Swimming Pool, Vastadevi Road, Katargam, Surat-395004</p>
                  <Button className="section-btn office-map-btn" onClick={() => window.open('https://maps.app.goo.gl/ESc9QzskAz8MRQWT7', '_blank')}>
                    <span className="btn-content"><img src={locationIcon} alt="Location icon" className="icon-img me-2" /> Click Here</span>
                  </Button>
                </div>
                <h4 className="contact-subheading mb-3">Contact No.</h4>
                <div className="d-flex flex-wrap gap-3 contact-numbers">
                  <a href="tel:+919920663357" className="section-btn contact-number-btn">
                    <span className="btn-content"><img src={phoneIcon} alt="Phone icon" className="icon-img me-2" /> +91 9920663357</span>
                  </a>
                  <a href="tel:+9102233927070" className="section-btn contact-number-btn">
                    <span className="btn-content"><img src={phoneIcon} alt="Phone icon" className="icon-img me-2" /> +91 022–33927070</span>
                  </a>
                </div>
              </div>
            </Col>
          </Row>
        </div>
      </Container>
    </section>
  );
};

export default ContactSection;
